import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useTheme } from '@/context/ThemeContext';
// UN SOLO IMPORT LIMPIO CON TODO LO NECESARIO
import { 
  Wrench, Shield, Search, Moon, Sun, Globe, Lock, Clock, Star, Quote,
  MapPin, Phone, MessageCircle, X, CheckCircle2, Monitor, Cpu, Zap, 
  LayoutGrid, Wifi, Database, Laptop, Layout, ShoppingBag, 
  ClipboardList, Activity, BarChart3, ShieldCheck, Settings 
} from 'lucide-react';

const PACKAGES = [
  {
    id: 'mantenimiento-preventivo',
    category: 'mantenimiento',
    title: "Mantenimiento Preventivo",
    price: "Desde $35",
    duration: "2-4 horas",
    icon: <Wrench className="w-8 h-8 text-blue-500" />,
    shortDesc: "Limpieza profunda y optimización para alargar la vida útil de tu equipo.",
    features: ["Limpieza interna física", "Cambio de pasta térmica", "Optimización de software"],
    details: {
      fullDescription: "Eliminamos el polvo, suciedad y residuos que causan sobrecalentamiento. Incluye aplicación de pasta térmica de alta calidad y limpieza de ventiladores.",
      problemsSolved: ["Sobrecalentamiento", "Ruido excesivo", "Lentitud por temperatura"],
      idealFor: "Equipos con más de 1 año sin servicio."
    }
  },
  {
    id: 'formateo-sistema',
    category: 'software',
    title: "Formateo y SO",
    price: "Desde $45",
    duration: "3-5 horas",
    icon: <Laptop className="w-8 h-8 text-purple-500" />,
    shortDesc: "Reinstalación limpia de Windows, Linux o macOS con drivers actualizados.",
    features: ["Respaldo de información", "Drivers oficiales", "Programas básicos (Office/PDF)"],
    details: {
      fullDescription: "Instalación desde cero del sistema operativo optimizado para tu hardware. Incluye configuración de BIOS/UEFI y eliminación de bloatware.",
      problemsSolved: ["Errores de sistema", "Virus/Malware", "Pantallazos azules"],
      idealFor: "Equipos que no arrancan o están sumamente lentos."
    }
  },
  {
    id: 'upgrade-ssd-ram',
    category: 'potenciacion',
    title: "Upgrade SSD y RAM",
    price: "Desde $25",
    duration: "1-2 horas",
    icon: <Zap className="w-8 h-8 text-yellow-500" />,
    shortDesc: "Aumenta la velocidad de tu PC o Laptop hasta 10 veces.",
    features: ["Migración de datos", "Instalación de hardware", "Pruebas de estabilidad"],
    details: {
      fullDescription: "Cambiamos tu viejo disco duro por un SSD de alta velocidad y ampliamos la memoria RAM para mejorar el multitareas.",
      problemsSolved: ["Arranque lento", "Programas que se traban", "Poco espacio"],
      idealFor: "MacBooks 2012+ y Laptops con disco mecánico."
    }
  },
  {
    id: 'eliminacion-amenazas',
    category: 'seguridad',
    title: "Limpieza de Virus",
    price: "Desde $30",
    duration: "1-3 horas",
    icon: <ShieldCheck className="w-8 h-8 text-green-500" />,
    shortDesc: "Detección y eliminación profunda de software malicioso sin perder archivos.",
    features: ["Escaneo profundo", "Eliminación de Adware", "Parche de vulnerabilidades"],
    details: {
      fullDescription: "Eliminamos troyanos, ransomware y malware. Aseguramos que tu sistema sea seguro y tus datos estén protegidos.",
      problemsSolved: ["Publicidad invasiva", "Robo de información", "Rendimiento inestable"],
      idealFor: "Usuarios con navegación web intensiva o sospecha de infección."
    }
  },
  {
    id: 'Empresarial-IT-Pro',
    category: 'empresarial',
    title: "Paquete IT Pro",
    price: "Cotización personalizada",
    duration: "1-3 días",
    icon: <Settings className="w-8 h-8 text-red-500" />,
    shortDesc: "Mantenimiento especializado para estaciones de trabajo y PCs de escritorio. Maximizamos el rendimiento de tu infraestructura informática para evitar paros técnicos en las jornadas laborales de tu empresa.",
    features: [
        "Diagnóstico técnico de hardware",
        "Repuestos certificados (Fuentes, Discos, RAM)",
        "Garantía de mano de obra corporativa",
        "Limpieza profunda de componentes internos"
    ],
    details: {
        fullDescription: "Reparamos y optimizamos torres y estaciones de trabajo. Incluye el reemplazo de componentes críticos como fuentes de poder, ventiladores, discos sólidos y tarjetas madre, además de la gestión térmica del procesador.",
        problemsSolved: [
            "PC no enciende o se apaga repentinamente",
            "Fallas de encendido por fuentes de poder dañadas",
            "Lentitud extrema y errores de sistema",
            "Sobrecalentamiento y ruidos en ventiladores",
            "Sobrecalentamiento y ruidos por ventiladores obstruidos"
        ],
        idealFor: "Empresas con flotas de PCs de escritorio que requieren alta disponibilidad y rendimiento constante."
    }
  },
  {
    id: 'ensamble-gamer',
    category: 'ensamble',
    title: "Ensamble High-End",
    price: "Desde $120",
    duration: "24-48 horas",
    icon: <Cpu className="w-8 h-8 text-purple-500" />,
    shortDesc: "Montaje profesional de PC Gamer o Workstation con gestión de cables avanzada.",
    features: ["Cable management pro", "Update BIOS", "Stress Test 24h"],
    details: {
      fullDescription: "Construimos tu estación de batalla con precisión quirúrgica. Optimizamos el flujo de aire y configuramos perfiles de rendimiento.",
      problemsSolved: ["PC no arranca", "Altas temperaturas", "Desorden interno"],
      idealFor: "Gamers y Editores de Video."
    }
  },
  {
    id: 'web-landing-pro',
    category: 'web',
    title: "Landing Page Empresarial",
    price: "Desde $150",
    duration: "3-5 días",
    icon: <Layout className="w-8 h-8 text-blue-600" />,
    shortDesc: "Página de aterrizaje optimizada para convertir visitantes en clientes.",
    features: ["Diseño Responsive", "Formulario de contacto", "Botón de WhatsApp"],
    details: {
      fullDescription: "Una página única (Single Page) diseñada específicamente para campañas de marketing. Estructura enfocada en ventas y velocidad de carga extrema.",
      problemsSolved: ["Baja conversión", "Presencia digital nula", "Falta de profesionalismo"],
      idealFor: "Lanzamiento de servicios o productos específicos."
    }
  },
  {
    id: 'web-corporativa',
    category: 'web',
    title: "Sitio Corporativo",
    price: "Desde $350",
    duration: "10-15 días",
    icon: <Globe className="w-8 h-8 text-indigo-600" />,
    shortDesc: "Sitio web completo para empresas que necesitan autoridad.",
    features: ["Hasta 5 secciones", "Blog/Noticias", "SEO Local básico"],
    details: {
      fullDescription: "Estructura profesional con secciones de Inicio, Nosotros, Servicios y Contacto.",
      problemsSolved: ["Poca información al cliente", "Marca desactualizada"],
      idealFor: "Pymes y consultorías."
    }
  },
  {
    id: 'web-ecommerce',
    category: 'web',
    title: "Tienda Online",
    price: "Desde $600",
    duration: "20-30 días",
    icon: <ShoppingBag className="w-8 h-8 text-orange-500" />,
    shortDesc: "Tu negocio abierto las 24 horas con carrito de compras.",
    features: ["Pasarela de pagos", "Gestión de inventario", "Panel administrativo"],
    details: {
      fullDescription: "Tienda virtual completa con pasarela de pagos integrada.",
      problemsSolved: ["Ventas manuales lentas", "Falta de control de stock"],
      idealFor: "Negocios que venden productos físicos."
    }
  },
  {
    id: 'web-catalogo',
    category: 'web',
    title: "Catálogo Digital",
    price: "Desde $250",
    duration: "7-10 días",
    icon: <ClipboardList className="w-8 h-8 text-emerald-500" />,
    shortDesc: "Muestra tus productos sin la complejidad de una pasarela de pagos.",
    features: ["Categorías ilimitadas", "Botón 'Consultar por WA'", "Galería HD"],
    details: {
      fullDescription: "Un sitio enfocado en mostrar visualmente tus productos y cerrar ventas por WhatsApp.",
      problemsSolved: ["Envío tedioso de PDFs", "Precios desactualizados"],
      idealFor: "Mayoristas y emprendedores."
    }
  }
];

const REVIEWS = [
  { id: 1, name: "John Miller", location: "Aurora, IL", rating: 5, service: "Reparación Hardware", comment: "Increíble servicio. Mi laptop Alienware no encendía y en 24 horas estaba como nueva. Muy profesionales.", date: "Hace 2 semanas" },
  { id: 2, name: "Sarah Jenkins", location: "Naperville, IL", rating: 5, service: "Desarrollo Web", comment: "Contraté a Atech Solucions para la página de mi restaurante. El diseño es moderno y ahora recibimos pedidos directo por la web.", date: "Hace 1 mes" },
  { id: 3, name: "Robert P.", location: "Aurora, IL", rating: 5, service: "Mantenimiento Pro", comment: "El mejor mantenimiento que le han hecho a mi MacBook. Bajó la temperatura notablemente. Vale cada centavo.", date: "Hace 3 días" }
];

export default function LandingPage() {
  const [trackingId, setTrackingId] = useState('');
  const [selectedPkg, setSelectedPkg] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const WHATSAPP_NUMBER = "16307709106";
  const marcas = ["DELL", "HP", "LENOVO", "APPLE", "ASUS", "ACER", "MSI", "SAMSUNG", "RAZER"];

  const categories = ['all', ...new Set(PACKAGES.map(pkg => pkg.category))];
  const filteredPackages = activeCategory === 'all' 
    ? PACKAGES 
    : PACKAGES.filter(pkg => pkg.category === activeCategory);

  const handleTrack = (e) => {
    e.preventDefault();
    if (trackingId.trim()) navigate(`/track/${trackingId.trim().toUpperCase()}`);
  };

  const openWhatsApp = (msg = "Hola, necesito información sobre sus servicios técnicos.") => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-300 selection:bg-primary selection:text-primary-foreground overflow-x-hidden">
      
      {/* NAVBAR */}
      <nav className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border/50">
        <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer shrink-0" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center shadow-lg shadow-primary/30">
              <Wrench className="w-5 h-5 text-primary-foreground" />
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-black text-xl tracking-tighter italic uppercase">Atech Solucions</span>
              <span className="text-[9px] font-bold uppercase tracking-widest opacity-60">Aurora, IL</span>
            </div>
          </div>

          <div className="hidden lg:flex items-center gap-2 bg-muted/40 p-1.5 rounded-full border border-border/50">
            <Button variant="ghost" className="rounded-full font-bold px-5 italic" onClick={() => scrollToSection('servicios')}>Servicios</Button>
            <Button variant="ghost" className="rounded-full font-bold px-5 italic" onClick={() => scrollToSection('resenas')}>Reseñas</Button>
            <Button variant="ghost" className="rounded-full font-bold px-5 italic" onClick={() => scrollToSection('contacto')}>Contacto</Button>
          </div>
          
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="icon" onClick={toggleTheme} className="rounded-full w-10 h-10">
              {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            </Button>
            <Link to="/login">
              <Button variant="outline" className="rounded-full font-bold border-primary/20 flex items-center gap-2 h-10">
                <Lock className="w-4 h-4" /> <span className="hidden sm:inline italic text-xs">ADMIN</span>
              </Button>
            </Link>
            <Button className="font-black rounded-full px-5 shadow-xl italic text-xs h-10 uppercase" onClick={() => openWhatsApp()}>AGENDAR</Button>
          </div>
        </div>
      </nav>

      {/* HERO SECTION */}
      <section className="relative pt-12 md:pt-24 pb-12 md:pb-16 px-4 text-center">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full md:w-[800px] h-[300px] bg-primary/10 blur-[100px] -z-10 animate-pulse"></div>
        <h1 className="text-5xl md:text-8xl font-black mb-6 tracking-tighter leading-[0.9] italic uppercase">
          Hardware <span className="text-primary">Lab</span> <br /> & Web <span className="underline decoration-primary/30">Studio</span>.
        </h1>
        <p className="text-base md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 font-medium italic">
          Servicio técnico premium y desarrollo digital en Aurora, Illinois.
        </p>

        <form onSubmit={handleTrack} className="max-w-xl mx-auto relative group px-2 mb-16">
          <div className="relative flex flex-col md:flex-row bg-background border border-border rounded-[2rem] p-2 shadow-2xl gap-2">
            <div className="flex items-center flex-1 px-4 py-3 md:py-0">
              <Search className="w-5 h-5 text-primary mr-3 shrink-0" />
              <Input
                type="text"
                placeholder="ID DE RASTREO"
                value={trackingId}
                onChange={(e) => setTrackingId(e.target.value)}
                className="border-0 h-10 md:h-14 text-lg focus-visible:ring-0 font-black bg-transparent p-0 uppercase"
              />
            </div>
            <Button type="submit" className="h-14 md:h-14 px-10 font-black rounded-2xl italic w-full md:w-auto">RASTREAR</Button>
          </div>
        </form>

        <div className="w-screen relative left-[50%] right-[50%] -ml-[50vw] -mr-[50vw] py-10 md:py-20 overflow-hidden bg-gradient-to-b from-transparent via-primary/5 to-transparent">
          <div className="flex whitespace-nowrap animate-infinite-scroll items-center">
            {[...marcas, ...marcas, ...marcas].map((m, i) => (
              <span key={i} className="mx-10 md:mx-20 text-5xl md:text-9xl font-black tracking-tighter text-muted-foreground/10 uppercase italic hover:text-primary/20 transition-colors cursor-default select-none">
                {m}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* SECCIÓN SERVICIOS FILTRADOS */}
      <section id="servicios" className="py-20 px-4 bg-muted/30 border-y border-border">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-8">
            <h2 className="text-3xl md:text-5xl font-black uppercase italic tracking-tighter border-l-8 border-primary pl-6">Soluciones</h2>
            
            <div className="flex flex-wrap gap-2 bg-background/50 p-2 rounded-3xl border border-border/50">
              {categories.map((cat) => (
                <Button
                  key={cat}
                  variant={activeCategory === cat ? "default" : "ghost"}
                  onClick={() => setActiveCategory(cat)}
                  className={`rounded-2xl font-black italic uppercase text-[10px] tracking-widest h-9 px-5 ${activeCategory === cat ? 'shadow-lg shadow-primary/20' : ''}`}
                >
                  {cat === 'all' && <LayoutGrid className="w-3 h-3 mr-2" />}
                  {cat}
                </Button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredPackages.map((pkg) => (
              <div key={pkg.id} className="group bg-card border border-border rounded-[3rem] p-8 md:p-10 hover:border-primary transition-all shadow-sm flex flex-col animate-in fade-in zoom-in duration-300">
                <div className="flex justify-between items-start mb-8">
                  <div className="transform group-hover:scale-110 transition-transform origin-left">{pkg.icon}</div>
                  <span className="text-[9px] font-black uppercase bg-primary/10 text-primary px-3 py-1 rounded-full italic tracking-tighter">{pkg.category}</span>
                </div>
                <h3 className="text-2xl font-black mb-4 tracking-tight italic uppercase">{pkg.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed mb-8 font-medium flex-1 italic">{pkg.shortDesc}</p>
                <div className="text-3xl font-black text-primary mb-8 italic tracking-tighter">{pkg.price}</div>
                <Button variant="outline" className="w-full rounded-2xl py-7 font-bold border-2 italic text-sm uppercase tracking-widest" onClick={() => setSelectedPkg(pkg)}>
                  Detalles Técnicos
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* RESEÑAS */}
      <section id="resenas" className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-center text-4xl md:text-6xl font-black tracking-tighter uppercase italic mb-16">Feedback <span className="text-primary">Real</span></h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {REVIEWS.map((rev) => (
              <div key={rev.id} className="relative bg-muted/20 p-8 rounded-[2.5rem] border border-border group hover:bg-card transition-colors">
                <Quote className="absolute top-6 right-8 w-12 h-12 text-primary/5" />
                <div className="flex gap-1 mb-6">
                  {[...Array(rev.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-primary text-primary" />)}
                </div>
                <p className="text-lg font-medium leading-relaxed mb-8 italic opacity-80">"{rev.comment}"</p>
                <div className="flex items-center gap-4 pt-6 border-t border-border">
                  <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center font-black text-primary-foreground italic">{rev.name[0]}</div>
                  <div>
                    <p className="font-black italic text-lg">{rev.name}</p>
                    <p className="text-[10px] text-muted-foreground font-black uppercase tracking-widest">{rev.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACTO */}
      <section id="contacto" className="py-20 px-4 bg-muted/30 border-t border-border">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-10">
            <h2 className="text-6xl md:text-7xl font-black tracking-tighter uppercase italic leading-[0.8]">Ubicación <br /><span className="text-primary">Aurora, IL</span></h2>
            <div className="space-y-6">
              <div className="flex items-start gap-5 p-8 rounded-[2.5rem] bg-card border border-border shadow-sm">
                <MapPin className="w-8 h-8 text-primary shrink-0" />
                <div>
                  <p className="font-black text-xl mb-1 italic uppercase tracking-tight">Taller Central</p>
                  <p className="text-muted-foreground font-medium text-lg italic">210 Plum St, Aurora, IL 60506</p>
                </div>
              </div>
              <div className="flex items-center gap-5 p-8 rounded-[2.5rem] bg-card border border-border font-black text-2xl italic cursor-pointer hover:border-primary transition-all" onClick={() => openWhatsApp()}>
                <Phone className="w-8 h-8 text-primary" /> (630) 770-9106
              </div>
            </div>
          </div>
          <div className="h-[400px] md:h-[550px] rounded-[3rem] md:rounded-[4rem] overflow-hidden border-[12px] border-card shadow-3xl">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2975.247161245802!2d-88.3297127!3d41.7610115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880ee91f2780e557%3A0x2f95709a34d0b67e!2s210%20Plum%20St%2C%20Aurora%2C%20IL%2060506!5e0!3m2!1ses!2sus!4v1700000000000" width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy"></iframe>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-16 border-t border-border text-center bg-muted/10">
        <p className="text-[10px] font-black uppercase tracking-[0.5em] opacity-30 italic px-4 leading-relaxed">
          © 2026 Atech Solucions — Aurora IL — High Performance Systems — All Rights Reserved
        </p>
      </footer>

      {/* WHATSAPP FLOTANTE */}
      <button onClick={() => openWhatsApp()} className="fixed bottom-6 right-6 bg-[#25D366] text-white p-5 rounded-full shadow-2xl hover:scale-110 transition-transform z-[60] animate-bounce">
        <MessageCircle className="w-8 h-8" />
      </button>

      {/* MODAL DETALLES */}
      {selectedPkg && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-background/95 backdrop-blur-xl">
          <div className="bg-card w-full max-w-2xl rounded-[3rem] p-8 md:p-12 relative border border-border shadow-2xl max-h-[90vh] overflow-y-auto no-scrollbar">
            <button onClick={() => setSelectedPkg(null)} className="absolute top-8 right-8 p-2 hover:bg-muted rounded-full transition-colors"><X className="w-8 h-8" /></button>
            <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-10">
              <div className="p-6 bg-primary/10 rounded-3xl shrink-0">{selectedPkg.icon}</div>
              <div className="text-center md:text-left">
                <h3 className="text-4xl font-black tracking-tighter italic leading-none mb-2 uppercase">{selectedPkg.title}</h3>
                <p className="text-primary font-black text-3xl tracking-tight">{selectedPkg.price}</p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-10">
              <div className="space-y-6">
                <p className="font-black text-[10px] uppercase tracking-widest text-muted-foreground italic">Protocolo</p>
                <p className="text-lg leading-relaxed italic opacity-80">{selectedPkg.details.fullDescription}</p>
                <div className="flex items-center gap-2 font-black text-primary italic uppercase text-xs bg-primary/5 p-4 rounded-2xl border border-primary/10 w-fit">
                  <Clock className="w-4 h-4"/> Duración: {selectedPkg.duration}
                </div>
              </div>
              <div className="space-y-6">
                <p className="font-black text-[10px] uppercase tracking-widest text-muted-foreground italic">Soluciona</p>
                <ul className="space-y-4">
                  {selectedPkg.details.problemsSolved.map((p, i) => (
                    <li key={i} className="flex items-center gap-3 font-bold text-sm italic tracking-tight"><CheckCircle2 className="w-5 h-5 text-primary shrink-0"/> {p}</li>
                  ))}
                </ul>
              </div>
            </div>
            <Button className="w-full mt-12 py-8 text-xl font-black rounded-3xl shadow-xl italic tracking-tighter uppercase" onClick={() => openWhatsApp(`Hola, me interesa el servicio de ${selectedPkg.title}.`)}>
              Solicitar Servicio
            </Button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes infinite-scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .animate-infinite-scroll { animation: infinite-scroll 40s linear infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        html { scroll-behavior: smooth; overflow-x: hidden; }
        body { overflow-x: hidden; width: 100%; }
      `}</style>
    </div>
  );
}